// extracted by mini-css-extract-plugin
module.exports = {"standardBtn":"Button_standardBtn__1lm8C"};